const LOCAL_DOMAIN =
  import.meta.env.VITE_APP_IROH_SERVICES_BASE_DOMAIN || "localhost"
export const IROH_SERVICES_API_PREFIX =
  ~~window.location.hostname.indexOf("local") >= 0
    ? `http://${LOCAL_DOMAIN}:8000/api/`
    : `https://${window.location.hostname}/api/`
